<template>
    <div class="container">
        <div v-html="html" @click="to"></div>
    </div>
</template>

<script setup>
import {onMounted, ref} from "vue";

const props = defineProps(['id'])
const emit = defineEmits()
const html = ref()

const to = async (event) => {
    let sigla = await getSigla(event.target.dataset.id)
    emit('to-sigla', sigla)
}

onMounted(async () => {
    let sigla = await getSigla(props.id)
    html.value = sigla.html
    await (new Promise(resolve => setTimeout(resolve, 1)));
    const elementos = document.querySelectorAll("[data-id]");
    for (const el of elementos) {
        let sigla = await getSigla(el.getAttribute('data-id'));
        el.setAttribute('title', sigla.description);
    }
})

const getSigla = async (id) => {
    return (await window.axios.get(`/api/viabilidade/siglas/${id}`)).data.data
}

</script>
<style scoped>
:deep(a) {
    color: blue !important; /* Cor do texto */
    text-decoration: underline !important; /* Sublinha o texto */
    cursor: pointer !important; /* Altera o cursor para indicar que é interativo */
}

:deep(a:hover) {
    color: darkblue !important; /* Mudança de cor ao passar o mouse */
}

</style>